import { Organisation } from "../organisation/OrganisationModelV2";
import { Person } from "../person/Person";
import { buildContractPhoto, buildReceiptPhotos, ContractPhoto } from "./ContractPhoto";
import { ContractSaleStatement } from "./ContractSaleStatement";
import { Harvest } from "./Harvest";
import { LineItem } from "./LineItem";

export class ContractBI {

    private contract: {
        id: number;
        marketDay: string;
        type: string;
        status: string;
        numberOfHarvests: number;
    };
    private who: Person;   // adapt Person build if needed
    private photos: ContractPhoto[];
    private attrMap: Record<string, any>;
    statements: ContractSaleStatement[]
    buyerOrg: Organisation
    transOrg: Organisation
    farmOrg: Organisation
    agentOrg: Organisation
    lineItems: LineItem[]

    constructor(d: any) {
        this.contract = d.contract;
        this.photos = d.photos || [];
        this.statements = d.statements
        this.buyerOrg = Organisation.build(d.organisations.find(o => o.type === "mill"))
        this.transOrg = Organisation.build(d.organisations.find(o => o.type === "transporter"))
        this.farmOrg = Organisation.build(d.organisations.find(o => o.type === "farm"))
        this.agentOrg = Organisation.build(d.organisations.find(o => o.type?.includes("agent")))
        this.lineItems = d.lineitems.map(li => LineItem.buildLineItem(li))
        this.photos = d.photos.map(p => buildContractPhoto(p))
    }
    getMargetDay(): string {
        return this.contract.marketDay
    }

    static build(d: any): ContractBI { return new ContractBI(d); }

    getType(): string { return this.contract.type; }

    getMarketDay(): string { return this.contract.marketDay; }

    getStatus(): string { return this.contract.status; }

    getId(): number { return this.contract.id; }

    getBuyerSaleStatement(): any {
        return this.statements?.at(0)
    }

    getBuyerLineItem(): LineItem[] {
        const buyerStatementId = this.getBuyerSaleStatement()?.id
        return this.lineItems.filter(li => li.statementId === buyerStatementId)
    }

    getHarvest(): Harvest[] {
        // No harvest info in sample; return empty
        return [];
    }

    harvestPhotos(): ContractPhoto[] {
        return this.photos
            .filter(p => p.type?.includes('fruit'))
            .sort((p, p1) => p.id - p1.id)
    }

    receiptPhotos(): ContractPhoto[] {
        return buildReceiptPhotos(this.photos)
    }

    getBuyer(): Organisation {
        return this.buyerOrg
    }

    getFarm(): Organisation | undefined { return this.farmOrg; }

    getAgent(): Organisation | undefined { return this.agentOrg; }

    getPersonTransporter(): Person | undefined {
        // Not present; return undefined
        return undefined;
    }
}